import { definePreset } from "@primeng/themes";
import Lara from "@primeng/themes/lara";
import { buttonConfig } from "@app/shared/general/config/primeng/themes/lara/components/button.config";
import { inputLaraThemeConfig } from "@app/shared/general/config/primeng/themes/lara/components/inputtext.config";
import { selectLaraThemeConfig } from "@app/shared/general/config/primeng/themes/lara/components/select.config";

export const laraTheme = definePreset(Lara, {
  primitive: {
    gray: {
      25: "#FDFDFD",
      50: "#FAFAFA",
      100: "#F5F5F5",
      200: "#E9EAEB",
      300: "#D5D7DA",
      400: "#A4A7AE",
      500: "#717680",
      600: "#535862",
      700: "#414651",
      800: "#252B37",
      900: "#181D27",
      950: "#0A0D12",
    },
    black: {
      25: "#f2f2f2",
      50: "#f2f2f2",
      100: "#c2c2c2",
      200: "#919191",
      300: "#616161",
      400: "#303030",
      500: "#000000",
      600: "#000000",
      700: "#000000",
      800: "#000000",
      900: "#000000",
      950: "#000000",
    },
    red: {
      50: "#FEF3F2",
      100: "#FEE4E2",
      200: "#FECDCA",
      300: "#FDA29B",
      400: "#F97066",
      500: "#F04438",
      600: "#D92D20",
      700: "#B42318",
      800: "#912018",
      900: "#7A271A",
      950: "#55160C",
    },
    green: {
      50: "#ECFDF3",
      100: "#DCFAE6",
      200: "#A9EFC5",
      300: "#75E0A7",
      400: "#47CD89",
      500: "#17B26A",
      600: "#079455",
      700: "#067647",
      800: "#085D3A",
      900: "#074D31",
      950: "#053321",
    },
    yellow: {
      50: "#FFFAEB",
      100: "#FEF0C7",
      200: "#FEDF89",
      300: "#FEC84B",
      400: "#FDB022",
      500: "#F79009",
      600: "#DC6803",
      700: "#B54708",
      800: "#93370D",
      900: "#7A2E0E",
      950: "#4E1D09",
    },
  },
  semantic: {
    primary: {
      0: "{black.0}",
      50: "{black.50}",
      100: "{black.100}",
      200: "{black.200}",
      300: "{black.300}",
      400: "{black.400}",
      500: "{black.500}",
      600: "{black.600}",
      700: "{black.700}",
      800: "{black.800}",
      900: "{black.900}",
      950: "{black.950}",
    },
    colorScheme: {
      light: {
        primary: {
          activeColor: "{primary.800}",
          color: "{primary.600}",
          hoverColor: "{primary.700}",
        },
      },
    },
    formField: {
      paddingY: "11px",
      paddingX: "11px",
      sm: {
        fontSize: "var(--font-size-text-16)",
        paddingY: "11px",
        paddingX: "11px",
      },
      extend: {
        sm: {
          lineHeight: "var(--line-height-text-24)",
        },
      },
    },
  },
  components: {
    button: buttonConfig,
    inputtext: inputLaraThemeConfig,
    password: inputLaraThemeConfig,
    select: selectLaraThemeConfig,
  },
});
